export default {"src":"/_next/static/media/copy_brand.d814557e.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};